import { useEffect } from 'react';
import { acceptIncoming, declineIncoming } from '@/lib/callActions';

/**
 * Welle 9: Macht die OS-Notification-Buttons („Annehmen"/„Ablehnen") wirksam.
 * Der Service Worker postet bei Klick `sw:notification_action`; hier wird die
 * Aktion mit gültigem Auth-Token ausgeführt. Zusätzlich wird der Kaltstart-Fall
 * über `?callaction=&callId=` abgedeckt (kein Fenster war offen).
 */
export function useNotificationActions() {
  useEffect(() => {
    function handle(action: string, callId?: string) {
      if (!callId) return;
      if (action === 'accept') void acceptIncoming(callId);
      else if (action === 'decline') void declineIncoming(callId);
      // 'open' → nichts tun; das Fenster ist bereits fokussiert und zeigt den Incoming-Screen.
    }

    function onSwMessage(e: MessageEvent) {
      const d = e.data;
      if (d && d.type === 'sw:notification_action') handle(d.action, d.callId);
    }
    navigator.serviceWorker?.addEventListener('message', onSwMessage);

    // Kaltstart über URL-Parameter (Fenster wurde durch die Notification geöffnet).
    try {
      const url = new URL(window.location.href);
      const action = url.searchParams.get('callaction');
      const callId = url.searchParams.get('callId');
      if (action && callId) {
        // URL bereinigen, damit ein Reload die Aktion nicht wiederholt.
        url.searchParams.delete('callaction');
        url.searchParams.delete('callId');
        window.history.replaceState({}, '', url.pathname + (url.search ? url.search : '') + url.hash);
        // kurz warten, bis Socket/Token bereit sind
        setTimeout(() => handle(action, callId), 800);
      }
    } catch { /* ignore */ }

    return () => navigator.serviceWorker?.removeEventListener('message', onSwMessage);
  }, []);
}
